import { FormattedMessage } from 'react-intl';
import { Field } from 'formik';
import FormTextField from '../../../common/form/FormTextField';
import DatePicker from '../../../common/form/DatePicker';
import TimePicker from '../../../common/form/TimePicker';
import {
  formatTimestampAsDate,
  formatTimestampAsDateWithTime,
  formatTimestampAsTime,
  getDateAtEndOfMonth,
  getDateAtStartOfMonth,
  getDateTodayAtGivenHour,
  getDifferenceInMonthBetweenTwoDates,
  getFormattedLastTwoWeeks, getFormattedNextDay,
  getFormattedNextMonth, getFormattedNextTwoWeeks, getFormattedNextWeek, getFormattedPreviousDay,
  getFormattedPreviousMonth, getFormattedPreviousWeek,
} from '../../../../utils/dates-utils';
import CommonSelectField from '../../../common/form/CommonSelectField';
import CommonCheckbox from '../../../common/form/CommonCheckbox';
import React from 'react';
import {
  BOOLEAN_FIELD_TYPE,
  DATE_FIELD_TYPE,
  DATE_TIME_FIELD_TYPE,
  NUMBER_FIELD_TYPE,
  SELECT_FIELD_TYPE,
  STRING_FIELD_TYPE,
  TIME_FIELD_TYPE,
  TIME_UNIT_FIELD_TYPE,
} from '../../../../utils/form-utils';
import {
  DATE_OPTIONS_STANDARD_REPORT, LAST_MONTH,
  LAST_TW0_WEEKS, LAST_WEEK, THIS_MONTH,
  THIS_WEEK,
  TIME_UNIT_OPTIONS,
  TODAY, YESTERDAY,
} from '../../../../utils/dates-const';
import { isDate, isMoney, isNumber, isQuantity } from '../../../../utils/report-utils';
import MoneyFormat from '../../../common/MoneyFormat';
import { EHK_SALES_OVERVIEW } from './StandardReportConfig';
import {
  ACTIVE_GIFT_CARDS_BALANCE,
  AMOUNT_OF_RETURNED_ITEMS,
  AMOUNT_OF_SOLD_GOODS_COLUMN,
  ARTICLE_NUMBER,
  ARTICLE_NUMBER_2,
  CAMPAIGN_COLUMN,
  CATEGORY_COLUMN,
  CAUSE_COLUMN,
  CUSTOMER_COLUMN,
  DATE_COLUMN,
  DATE_COLUMN_2,
  DATE_COLUMN_3,
  DESCRIPTION_COLUMN,
  EMPLOYEE_COLUMN,
  EMPLOYEE_ID_COLUMN,
  GIFT_CARDS_QUANTITY,
  INACTIVE_GIFT_CARDS_BALANCE,
  ITEM_COLUMN,
  NAME_COLUMN,
  NET_NUMBER_OF_SOLD_GOODS,
  NET_PURCHASE_PRICE_OF_SOLD_GOODS_EXCL_VAT,
  NET_QUANTITY_VALUE,
  NET_SALES_EXCL_VAT,
  NET_SALES_INCL_VAT,
  NET_SALES_SUM_VAT,
  NUMBER_OF_RETURNED_ITEMS,
  NUMBER_OF_SOLD_GOODS_COLUMN,
  PAYMENT_TYPE,
  PERSONAL_NAME_COLUMN,
  PERSONAL_NUMBER_COLUMN,
  PURCHASE_PRICE_EXCL_VAT_PCS,
  PURCHASE_PRICE_OF_RETURNED_GOODS_EXCL_VAT,
  PURCHASE_PRICE_OF_SOLD_GOODS_EXCL_VAT,
  QUANTITY_COLUMN,
  RETURNS_EXCL_VAT,
  RETURNS_INCL_VAT,
  RETURNS_SUM_VAT,
  SALES_EXCL_VAT,
  SALES_INCL_VAT,
  SALES_VAT_PROPERTY,
  SUM_COLUMN,
  SUPPLIER_COLUMN,
  TOTAL_PRICE_COLUMN,
  TOTAL_PROFIT,
  TOTAL_PROFIT_EXCL_VAT,
  TOTAL_PURCHASE_PRICE_EXCL_VAT,
  TOTAL_QUANTITY_COLUMN,
  TRANSACTION_TYPE,
  TYPE_COLUMN,
  PRODUCT_COLUMN,
  TOTAL_PRICE_INCL_VAT_COLUMN,
  NUMBER_COLUMN,
  CASH_REGISTER_COLUMN,
  DATE_TIME_COLUMN,
  EMPLOYEE_NAME_COLUMN,
  TOTAL_AMOUNT_WITH_VAT,
  FILE_COLUMN,
  TYPE_COLUMN_2,
  CREATED_BY_COLUMN,
  CREATED_BY_COLUMN_2,
  RECEIPTS_QUANTITY,
  RETURNS_QUANTITY,
  Z_REPORT_NUMBER,
  AMOUNT_OF_TRANSACTIONS,
  SOLD_GIFT_CARDS,
  OVERVIEW_TOTAL,
  CURRENT_BALANCE_STOCK,
  PAYMENT_TYPE_CARD,
  PAYMENT_TYPE_CASH,
  PAYMENT_TYPE_SWISH,
  INVOICE_COLUMN,
  PAYMENT_COLUMN, PAYMENT_IDENTIFIER,
} from './StandardReportConsts';

export const NAME_FIELD = { name: 'Namn', type: STRING_FIELD_TYPE };

export const PERSONAL_NR_FIELD = { name: 'personalNumber', type: STRING_FIELD_TYPE, server: 'Personalnr.' };

export const FREE_TEXT_FIELD = { name: 'Fritext', type: STRING_FIELD_TYPE };

export const EMPLOYEE_FIELD = { name: 'Anställd', type: STRING_FIELD_TYPE };

export const CAMPAIGN_FIELD = { name: 'Kampanj', type: STRING_FIELD_TYPE };

export const GIFT_CARD_FIELD = { name: 'Presentkort', type: STRING_FIELD_TYPE };

export const PRODUCT_KATEGORI_FIELD = { name: 'Produkt / Kategori', type: STRING_FIELD_TYPE };

export const PRODUCT_FIELD = { name: 'Produkt', type: STRING_FIELD_TYPE };

export const CUSTOMER_FIELD = { name: 'Kund', type: STRING_FIELD_TYPE };

export const PURCHASE_REFILL_GIFTS_CARDS_FIELD = { name: 'Köp / påfyllning av presentkort', type: BOOLEAN_FIELD_TYPE };

export const PAYMENT_BY_GIFT_CARD_FIELD = { name: 'Betalning med presentkort', type: BOOLEAN_FIELD_TYPE };

export const DEPOSIT_FIELD = { name: 'Insättning', type: BOOLEAN_FIELD_TYPE };

export const WITHDRAWAL_FIELD = { name: 'Uttag', type: BOOLEAN_FIELD_TYPE };

export const INCLUDE_INVOICES_FIELD = { name: 'Inkludera fakturor', type: BOOLEAN_FIELD_TYPE };

export const DATE_FROM_FIELD = { name: 'dateFrom', type: DATE_FIELD_TYPE, server: 'Fr.o.m.-datum' };

export const DATE_TO_FIELD = { name: 'dateTo', type: DATE_FIELD_TYPE, server: 'T.o.m.-datum' };

export const TOP_SALES_QUANTITY = { name: 'topSalesQuantity', type: NUMBER_FIELD_TYPE, server: 'Topplista, antal' };

export const DATE_TIME_FROM_FIELD = {
  name: 'dateTimeFrom',
  type: DATE_TIME_FIELD_TYPE,
  server: 'Fr.o.m.-datum & klockslag',
};

export const DATE_TIME_TO_FIELD = {
  name: 'dateTimeTo',
  type: DATE_TIME_FIELD_TYPE,
  server: 'T.o.m.-datum & klockslag',
};

export const DATE_FIELD = { name: 'date', type: DATE_FIELD_TYPE };

export const TIME_FROM_FIELD = { name: 'timeFrom', type: TIME_FIELD_TYPE, server: 'Fr.o.m.-tid' };

export const TIME_TO_FIELD = { name: 'timeTo', type: TIME_FIELD_TYPE, server: 'T.o.m.-tid' };

export const TIME_UNIT_FIELD = { name: 'Period-typ', type: TIME_UNIT_FIELD_TYPE };

export const FIELDS_NEED_TO_BE_CONVERTED = [PERSONAL_NR_FIELD, DATE_FROM_FIELD, DATE_TO_FIELD, DATE_TIME_FROM_FIELD, DATE_TIME_TO_FIELD, TIME_FROM_FIELD, TIME_TO_FIELD, TOP_SALES_QUANTITY];

export const TODAY_AS_DATE = new Date();
export const FIRST_DAY_OF_CURRENT_MONTH = getDateAtStartOfMonth(new Date());
export const LAST_DAY_OF_CURRENT_MONTH = getDateAtEndOfMonth(new Date());
export const SIX_AM = getDateTodayAtGivenHour(6);

export function getConvertedFieldValue(fieldType, value) {
  switch (fieldType) {
    case DATE_FIELD_TYPE:
      return formatTimestampAsDate(value);
    case DATE_TIME_FIELD_TYPE:
      return formatTimestampAsDateWithTime(value);
    case TIME_FIELD_TYPE:
      return formatTimestampAsTime(value);
    default:
      return value;
  }
}

export const getValueForCell = (key, value) => {
  if (isQuantity(value, key)) {
    return Math.round(value);
  } else if (isMoney(value)) {
    return <MoneyFormat value={value} />;
  } else if (isDate(key)) {
    return formatTimestampAsDateWithTime(Date.parse(value));
  } else if (isNumber(value)) {
    return Math.round(value);
  }
  return value;
};

export const reportConfigForRegularTable = (firstReportFromList) => {
  return firstReportFromList.map(key => ({
    header: key.includes('|') ? key.replace(/\*/g, '').split('|')[0] : key,
    subheader: key.includes('|') ? key.replace(/\*/g, '').split('|')[1] : undefined,
    value: report => getValueForCell(key, report[key] && report[key].includes('*') ? report[key].replace(/\*/g, '') : report[key]),
    align: report => isMoney(report[key], key) ? 'right' : 'center',
  }));
};

function extraHandleChangeActionLogic(field, form) {
  switch (field.name) {
    case WITHDRAWAL_FIELD.name:
    case DEPOSIT_FIELD.name: {
      const secondField = field.name === WITHDRAWAL_FIELD.name ? DEPOSIT_FIELD.name : WITHDRAWAL_FIELD.name;
      const currentFieldValue = form.values[field.name];
      const secondFieldValue = form.values[secondField];
      if (currentFieldValue && !secondFieldValue) {
        form.setFieldValue(secondField, true);
        form.setFieldValue(field.name, false);
      } else {
        form.setFieldValue(field.name, !currentFieldValue);
      }
      break;
    }
    default:
      break;
  }
}

export function renderStandardReportFormFields(fields, form) {
  return (
    // eslint-disable-next-line array-callback-return
    fields.map((field, index) => {
      // eslint-disable-next-line default-case
      switch (field.type) {
        case STRING_FIELD_TYPE:
          return <Field
            variant="standard"
            key={index}
            name={field.name}
            component={FormTextField}
            label={getLabelForField(field.name)}
          />;
        case NUMBER_FIELD_TYPE:
          return <Field
            variant="standard"
            type="number"
            key={index}
            name={field.name}
            component={FormTextField}
            label={getLabelForField(field.name)}
          />;
        case  DATE_FIELD_TYPE:
          return <Field
            key={index}
            name={field.name}
            label={getLabelForField(field.name)}
            component={DatePicker}
          />;
        case  DATE_TIME_FIELD_TYPE:
          return <Field
            withTime
            key={index}
            name={field.name}
            label={getLabelForField(field.name)}
            component={DatePicker}
          />;
        case  TIME_FIELD_TYPE:
          return <Field
            key={index}
            name={field.name}
            label={getLabelForField(field.name)}
            component={TimePicker}
          />;
        case  TIME_UNIT_FIELD_TYPE:
          return <Field
            key={index}
            name={field.name}
            label={getLabelForField(field.name)}
            options={TIME_UNIT_OPTIONS}
            component={CommonSelectField}
          />;
        case BOOLEAN_FIELD_TYPE:
          return <Field
            center
            key={index}
            name={field.name}
            label={getLabelForField(field.name)}
            component={CommonCheckbox}
            extraHandleChangeAction={() => extraHandleChangeActionLogic(field, form)}
          />;
        case SELECT_FIELD_TYPE:
          return <Field
            key={index}
            name={field.name}
            options={field.options}
            label={getLabelForField(field.name)}
            component={CommonSelectField}
          />;
      }
    })
  );
}

function getLabelForField(fieldName) {
  switch (fieldName) {
    case PERSONAL_NR_FIELD.name:
      return (
        <FormattedMessage
          id="field.personal.nr"
          defaultMessage="Personal no."
        />
      );
    case GIFT_CARD_FIELD.name:
      return (
        <FormattedMessage
          id="field.gift.card"
          defaultMessage="Gift card"
        />
      );
    case DATE_FROM_FIELD.name:
      return (
        <FormattedMessage
          id="date.field.date.from"
          defaultMessage="Date from"
        />
      );
    case DATE_TO_FIELD.name:
      return (
        <FormattedMessage
          id="date.field.date.to"
          defaultMessage="Date to"
        />
      );
    case DATE_TIME_FROM_FIELD.name:
      return (
        <FormattedMessage
          id="date.field.date.time.from"
          defaultMessage="Date & time from"
        />
      );
    case DATE_TIME_TO_FIELD.name:
      return (
        <FormattedMessage
          id="date.field.date.time.to"
          defaultMessage="Date & time to"
        />
      );
    case DATE_FIELD.name:
      return (
        <FormattedMessage
          id="date.field.date"
          defaultMessage="Date"
        />
      );
    case TIME_FROM_FIELD.name:
      return (
        <FormattedMessage
          id="date.field.time.from"
          defaultMessage="Time from"
        />
      );
    case TIME_TO_FIELD.name:
      return (
        <FormattedMessage
          id="date.field.time.to"
          defaultMessage="Time to"
        />
      );
    case TIME_UNIT_FIELD.name:
      return (
        <FormattedMessage
          id="date.field.period.type"
          defaultMessage="Period type"
        />
      );
    case PURCHASE_REFILL_GIFTS_CARDS_FIELD.name:
      return (
        <FormattedMessage
          id="field.purchase.refill.gifts.cards"
          defaultMessage="Purchase / refill gift cards"
        />
      );
    case PAYMENT_BY_GIFT_CARD_FIELD.name:
      return (
        <FormattedMessage
          id="field.payment.gift.card"
          defaultMessage="Payment by gift card"
        />
      );
    case DEPOSIT_FIELD.name:
      return (
        <FormattedMessage
          id="field.deposit"
          defaultMessage="Deposit"
        />
      );
    case WITHDRAWAL_FIELD.name:
      return (
        <FormattedMessage
          id="field.withdrawal"
          defaultMessage="Withdrawal"
        />
      );
    case INCLUDE_INVOICES_FIELD.name:
      return (
        <FormattedMessage
          id="field.include.invoices"
          defaultMessage="Include invoices"
        />
      );
    default:
      return fieldName;
  }
}

export const AVERAGE_SALES_TABLE_HEADERS_INDEXES = [0, 1, 8, 15, 22, 29, 36, 43, 50, 57, 64, 71];

export const AVERAGE_SALES_TABLE_NUMBER_OF_SUBHEADERS_PER_HEADER = 7;

export const isMoreThan6Months = (date1, date2) => {
  return getDifferenceInMonthBetweenTwoDates(date1, date2) > 6;
};

export const isAverageSalesReport = (reportName) => {
  return reportName === EHK_SALES_OVERVIEW.reportName;
};

export const getHeaderTranslationForStandardReports = (formatMessage, header) => {
  switch (header) {
    case DATE_COLUMN:
    case DATE_COLUMN_2:
    case DATE_COLUMN_3:
      return formatMessage({ id: 'report.chart.Date', defaultMessage: 'Date' });
    case CREATED_BY_COLUMN:
    case CREATED_BY_COLUMN_2:
      return formatMessage({ id: 'report.chart.CreatedBy', defaultMessage: 'Created by' });
    case ARTICLE_NUMBER:
    case ARTICLE_NUMBER_2:
      return formatMessage({ id: 'report.chart.ArticleNumber', defaultMessage: 'Product code' });
    case TYPE_COLUMN:
    case TYPE_COLUMN_2:
      return formatMessage({ id: 'report.chart.Type', defaultMessage: 'Type' });
    case DATE_TIME_COLUMN:
      return formatMessage({ id: 'date.time', defaultMessage: 'Date & time' });
    case CUSTOMER_COLUMN:
      return formatMessage({ id: 'report.chart.Customer', defaultMessage: 'Customer' });
    case CATEGORY_COLUMN:
      return formatMessage({ id: 'report.chart.Category', defaultMessage: 'Category' });
    case AMOUNT_OF_SOLD_GOODS_COLUMN:
      return formatMessage({ id: 'report.chart.NumberOfSoldGoods', defaultMessage: 'Amount of sold goods' });
    case CURRENT_BALANCE_STOCK:
      return formatMessage({ id: 'report.chart.StockBalance', defaultMessage: 'Current inventory balance' });
    case NUMBER_OF_SOLD_GOODS_COLUMN:
      return formatMessage({ id: 'report.chart.NumberOfSoldGoods', defaultMessage: 'Number of sold goods' });
    case NET_NUMBER_OF_SOLD_GOODS:
      return formatMessage({ id: 'report.chart.NetAmount', defaultMessage: 'Net number of sold goods' });
    case AMOUNT_OF_RETURNED_ITEMS:
      return formatMessage({ id: 'report.chart.AmountOfReturnedItems', defaultMessage: 'Amount of returned items' });
    case NUMBER_OF_RETURNED_ITEMS:
      return formatMessage({ id: 'report.chart.NetReturnedItems', defaultMessage: 'Number of returned items' });
    case SALES_VAT_PROPERTY:
      return formatMessage({ id: 'report.chart.SalesTotalVat', defaultMessage: 'Sales VAT' });
    case SALES_INCL_VAT:
      return formatMessage({ id: 'report.chart.SalesInclVat', defaultMessage: 'Sales incl. VAT' });
    case SALES_EXCL_VAT:
      return formatMessage({ id: 'report.chart.SalesExclVat', defaultMessage: 'Sales excl. VAT' });
    case NET_QUANTITY_VALUE:
      return formatMessage({ id: 'report.chart.NetQuantity', defaultMessage: 'Net quantity' });
    case RETURNS_INCL_VAT:
      return formatMessage({ id: 'report.chart.ReturnsInclVat', defaultMessage: 'Returns incl. VAT' });
    case RETURNS_EXCL_VAT:
      return formatMessage({ id: 'report.chart.ReturnsExclVat', defaultMessage: 'Returns excl. VAT' });
    case RETURNS_SUM_VAT:
      return formatMessage({ id: 'report.chart.ReturnsSumVat', defaultMessage: 'Returns sum VAT' });
    case NET_SALES_INCL_VAT:
      return formatMessage({ id: 'report.chart.NetSalesInclVat', defaultMessage: 'Net sales incl. VAT' });
    case NET_SALES_EXCL_VAT:
      return formatMessage({ id: 'report.chart.NetSalesExclVat', defaultMessage: 'Net sales excl. VAT' });
    case NET_SALES_SUM_VAT:
      return formatMessage({ id: 'report.chart.NetSalesSumVat', defaultMessage: 'Net sales sum VAT' });
    case PURCHASE_PRICE_OF_SOLD_GOODS_EXCL_VAT:
      return formatMessage({
        id: 'report.chart.PurchasePriceOfSoldGoodsExclVat',
        defaultMessage: 'Purchase price of sold goods excl. VAT',
      });
    case PURCHASE_PRICE_OF_RETURNED_GOODS_EXCL_VAT:
      return formatMessage({
        id: 'report.chart.PurchasePriceOfReturnedGoodsExclVat',
        defaultMessage: 'Purchase price of returned goods excl. VAT',
      });
    case NET_PURCHASE_PRICE_OF_SOLD_GOODS_EXCL_VAT:
      return formatMessage({
        id: 'report.chart.NetPurchasePriceOfSoldGoodsExclVat',
        defaultMessage: 'Net purchase price of sold goods excl. VAT',
      });
    case TOTAL_PROFIT_EXCL_VAT:
      return formatMessage({ id: 'report.chart.TotalProfitExclVat', defaultMessage: 'Total profit excl. VAT' });
    case TOTAL_PROFIT:
      return formatMessage({ id: 'report.chart.TotalProfit', defaultMessage: 'Total profit' });
    case PAYMENT_TYPE:
      return formatMessage({ id: 'report.sie4.payment.type', defaultMessage: 'Payment type' });
    case PAYMENT_TYPE_CASH:
      return formatMessage({ id: 'report.payment.type.cash', defaultMessage: 'Cash (payment)' });
    case PAYMENT_TYPE_CARD:
      return formatMessage({ id: 'report.payment.type.card', defaultMessage: 'Card (payment)' });
    case PAYMENT_TYPE_SWISH:
      return formatMessage({ id: 'report.payment.type.swish', defaultMessage: 'Swish (payment)' });
    case TRANSACTION_TYPE:
      return formatMessage({ id: 'transaction.type', defaultMessage: 'Transaction type' });
    case SUM_COLUMN:
      return formatMessage({ id: 'report.chart.Sum', defaultMessage: 'Sum' });
    case EMPLOYEE_ID_COLUMN:
      return formatMessage({ id: 'report.chart.EmployeeID', defaultMessage: 'Employee ID' });
    case EMPLOYEE_COLUMN:
      return formatMessage({ id: 'report.chart.Employee', defaultMessage: 'Employee' });
    case PERSONAL_NUMBER_COLUMN:
      return formatMessage({ id: 'field.personal.nr', defaultMessage: 'Personal number' });
    case NAME_COLUMN:
      return formatMessage({ id: 'report.chart.Name', defaultMessage: 'Name' });
    case TOTAL_PRICE_COLUMN:
      return formatMessage({ id: 'report.chart.TotalPrice', defaultMessage: 'Total price' });
    case QUANTITY_COLUMN:
      return formatMessage({ id: 'report.chart.Quantity', defaultMessage: 'Quantity' });
    case TOTAL_QUANTITY_COLUMN:
      return formatMessage({ id: 'report.chart.TotalQuantity', defaultMessage: 'Total quantity' });
    case CAUSE_COLUMN:
      return formatMessage({ id: 'report.chart.Cause', defaultMessage: 'Cause' });
    case ITEM_COLUMN:
      return formatMessage({ id: 'report.chart.ItemOf', defaultMessage: 'Item' });
    case DESCRIPTION_COLUMN:
      return formatMessage({ id: 'report.chart.Description', defaultMessage: 'Description' });
    case PERSONAL_NAME_COLUMN:
      return formatMessage({ id: 'report.chart.PersonalName', defaultMessage: 'Personal name' });
    case PURCHASE_PRICE_EXCL_VAT_PCS:
      return formatMessage({ id: 'report.chart.PurchasePriceExclVatPcs', defaultMessage: 'Total price excl. VAT/PCS' });
    case TOTAL_PURCHASE_PRICE_EXCL_VAT:
      return formatMessage({
        id: 'report.chart.TotalPurchasePriceExclVat',
        defaultMessage: 'Total purchase price excl. VAT',
      });
    case GIFT_CARDS_QUANTITY:
      return formatMessage({ id: 'report.chart.GiftCardsQuantity', defaultMessage: 'Gift cards quantity' });
    case ACTIVE_GIFT_CARDS_BALANCE:
      return formatMessage({ id: 'report.chart.ActiveGiftCardsBalance', defaultMessage: 'Active gift cards balance' });
    case INACTIVE_GIFT_CARDS_BALANCE:
      return formatMessage({
        id: 'report.chart.InactiveGiftCardsBalance',
        defaultMessage: 'Inactive gift cards balance',
      });
    case PRODUCT_COLUMN:
      return formatMessage({ id: 'report.chart.Product', defaultMessage: 'Product' });
    case CAMPAIGN_COLUMN:
      return formatMessage({ id: 'report.chart.Campaign', defaultMessage: 'Campaign' });
    case SUPPLIER_COLUMN:
      return formatMessage({ id: 'report.chart.Supplier', defaultMessage: 'Supplier' });
    case TOTAL_PRICE_INCL_VAT_COLUMN:
      return formatMessage({ id: 'report.chart.TotalPriceInclVat', defaultMessage: 'Total price incl. VAT' });
    case NUMBER_COLUMN:
      return formatMessage({ id: 'report.chart.Transaction', defaultMessage: 'Number' });
    case PAYMENT_COLUMN:
      return formatMessage({ id: 'report.payment', defaultMessage: 'Payment type' });
    case PAYMENT_IDENTIFIER:
      return formatMessage({ id: 'report.payment.identifier', defaultMessage: 'Terminal' });
    case INVOICE_COLUMN:
      return formatMessage({ id: 'report.chart.InvoiceNumber', defaultMessage: 'Invoice nr.' });
    case Z_REPORT_NUMBER:
      return formatMessage({ id: 'report.zreport.number', defaultMessage: 'Z-report nr.' });
    case CASH_REGISTER_COLUMN:
      return formatMessage({ id: 'field.cash.register', defaultMessage: 'Cash register' });
    case EMPLOYEE_NAME_COLUMN:
      return formatMessage({ id: 'employee.name', defaultMessage: 'Employee name' });
    case TOTAL_AMOUNT_WITH_VAT:
      return formatMessage({ id: 'total.amount.vat', defaultMessage: 'Amount (incl. VAT)' });
    case FILE_COLUMN:
      return formatMessage({ id: 'download.file', defaultMessage: 'Download file' });
    case RECEIPTS_QUANTITY:
      return formatMessage({ id: 'report.chart.ReceiptsQuantity', defaultMessage: 'Total receipts' });
    case RETURNS_QUANTITY:
      return formatMessage({ id: 'report.chart.ReturnsQuantity', defaultMessage: 'Total returns' });
    case AMOUNT_OF_TRANSACTIONS:
      return formatMessage({ id: 'sales.overview.column.antal', defaultMessage: 'Amount of transactions' });
    case SOLD_GIFT_CARDS:
      return formatMessage({ id: 'sales.overview.column.giftcards', defaultMessage: 'Sold gift cards' });
    case OVERVIEW_TOTAL:
      return formatMessage({ id: 'sales.overview.column.total', defaultMessage: 'Total' });
    default:
      return header;
  }
};

export const areValuesOutOfDateRange = (values) => {
  const propertyNames = ['dateFrom', 'dateTimeFrom', 'dateTo', 'dateTimeTo'];
  const hasDateRange = propertyNames.some((prop) => prop in values);
  const dateFrom = (values.dateFrom || values.dateTimeFrom);
  const dateTo = (values.dateTo || values.dateTimeTo);
  
  if (hasDateRange) {
    const dateRangeIdx = values.dateRange - 1;
    const currentOptions = DATE_OPTIONS_STANDARD_REPORT[dateRangeIdx];
    return currentOptions?.option.dateFrom !== (dateFrom) && currentOptions?.option.dateTo !== (dateTo);
  }
  return true;
};

export const getLabelForPrevButton = (dateRangeValue, classes) => {
  if ([TODAY.value, YESTERDAY.value].includes(dateRangeValue)) {
    return <span className={classes.btnLabel}><FormattedMessage id="previous.day" defaultMessage="Prev day" /></span>;
  } else if ([THIS_WEEK.value, LAST_WEEK.value].includes(dateRangeValue)) {
    return <span className={classes.btnLabel}><FormattedMessage id="previous.week" defaultMessage="Prev week" /></span>;
  } else if ([LAST_TW0_WEEKS.value].includes(dateRangeValue)) {
    return <span className={classes.btnLabel}><FormattedMessage id="previous.two.weeks" defaultMessage="Prev 2 weeks" /></span>;
  } else if ([THIS_MONTH.value, LAST_MONTH.value].includes(dateRangeValue)) {
    return <span className={classes.btnLabel}><FormattedMessage id="previous.month"
                                                                defaultMessage="Prev month" /></span>;
  }
};

export const getLabelForNextButton = (dateRangeValue, classes) => {
  if ([TODAY.value, YESTERDAY.value].includes(dateRangeValue)) {
    return <span className={classes.btnLabel}><FormattedMessage id="next.day" defaultMessage="Next day" /></span>;
  } else if ([THIS_WEEK.value, LAST_WEEK.value].includes(dateRangeValue)) {
    return <span className={classes.btnLabel}><FormattedMessage id="next.week" defaultMessage="Next week" /></span>;
  } else if ([LAST_TW0_WEEKS.value].includes(dateRangeValue)) {
    return <span className={classes.btnLabel}><FormattedMessage id="next.two.weeks"
                                                                defaultMessage="Next 2 weeks" /></span>;
  } else if ([THIS_MONTH.value, LAST_MONTH.value].includes(dateRangeValue)) {
    return <span className={classes.btnLabel}><FormattedMessage id="next.month" defaultMessage="Next month" /></span>;
  }
};

function adjustEndDate(endDateStr, isTimeIncluded) {
  let endDate = new Date(endDateStr);
  if (isTimeIncluded) {
    endDate.setDate(endDate.getDate() + 1);
  }
  return endDate;
}

export const updateDateRangeFields = (direction, values, setFieldValue, validateForm, dateRangeValue, isTimeIncluded = false) => {
  const isPrevious = direction === 'previous';
  const dayFunction = isPrevious ? getFormattedPreviousDay : getFormattedNextDay;
  const weekFunction = isPrevious ? getFormattedPreviousWeek : getFormattedNextWeek;
  const twoWeekFunction = isPrevious ? getFormattedLastTwoWeeks : getFormattedNextTwoWeeks;
  const monthFunction = isPrevious ? getFormattedPreviousMonth : getFormattedNextMonth;
  
  const functionMapping = {
    [TODAY.value]: dayFunction,
    [YESTERDAY.value]: dayFunction,
    [THIS_WEEK.value]: weekFunction,
    [LAST_WEEK.value]: weekFunction,
    [LAST_TW0_WEEKS.value]: twoWeekFunction,
    [LAST_MONTH.value]: monthFunction,
    [THIS_MONTH.value]: monthFunction,
  };
  
  const selectedFunction = functionMapping[dateRangeValue];
  if (!selectedFunction) {
    console.error('Date range error:', dateRangeValue);
    return;
  }
  
  const result = selectedFunction(values.dateFrom);
  if (!result || !result.start || !result.end) {
    console.error('Date return & date start error.');
    return;
  }
  
  const adjustedEndDate = adjustEndDate(result.end, isTimeIncluded);
  setFieldValue('dateFrom', result.start);
  setFieldValue('dateTo', adjustedEndDate);
  validateForm({ dateFrom: result.start, dateTo: adjustedEndDate });
};

export const checkIfTimeFieldsAreUsed = (fields) => {
  return fields.some(field => field.name === 'timeTo');
};

export const isTotalCategory = ({ row }) => {
  return row?.Kategori === 'Totalt' || row?.Period === 'Total';
};

export const isIdSelected = ({ row, reportName, id }) => {
  return reportName === 'Transactions' && row.Id === id;
};

export const handleClassnames = ({ params, reportName, id }) => {
  if (isTotalCategory(params)) return 'totalCategory';
  if (isIdSelected({ ...params, reportName, id })) return 'selectedId';
};